/**
 * 뉴스레터 구독 신청 저장용 Firebase 연동.
 *
 * firebase SDK는 번들이 크기 때문에 정적 import 하지 않고,
 * 실제로 폼을 제출하는 순간에만 동적으로 불러온다.
 * (뉴스레터를 읽기만 하는 방문자는 SDK를 내려받지 않는다.)
 *
 * 설정값은 .env 의 REACT_APP_FIREBASE_* 에서 읽는다.
 * Firebase 웹 apiKey는 설계상 공개되는 값이라 저장소에 두어도 무방하며,
 * 실제 접근 제어는 firestore.rules 가 담당한다.
 */

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
};

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId
);

let firestorePromise = null;

function loadFirestore() {
  if (!firestorePromise) {
    firestorePromise = (async () => {
      const [{ initializeApp, getApps, getApp }, firestore] = await Promise.all([
        import("firebase/app"),
        import("firebase/firestore"),
      ]);

      const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

      return { db: firestore.getFirestore(app), firestore };
    })();
  }

  return firestorePromise;
}

/**
 * 구독 신청 1건을 subscribers 컬렉션에 추가한다.
 * email 과 phone 은 각각 비어 있을 수 있고(둘 중 하나만 남겨도 된다), 빈 값은 null 로 넣는다.
 * firestore.rules 에서 create만 허용하므로, 저장된 문서는 웹에서 읽거나 고칠 수 없다.
 */
export async function addSubscriber({ email, phone, source }) {
  if (!isFirebaseConfigured) {
    throw new Error("FIREBASE_NOT_CONFIGURED");
  }

  const { db, firestore } = await loadFirestore();

  await firestore.addDoc(firestore.collection(db, "subscribers"), {
    email: email || null,
    phone: phone || null,
    source: source || "unknown",
    consent: true,
    createdAt: firestore.serverTimestamp(),
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 300) : null,
  });
}
